import GitlabBotConnected from '../../../containers/source-integration/independent-integrations/gitlab-bot'

export const gitlabBot = {
  component: GitlabBotConnected,
  data: {
    title: 'Spectral Gitlab Bot',
    tileKey: 'gitlab-bot',
  },
}
